<template>
  <div class="row d-flex justify-content-xl-center">
    <div class="panel-heading text-center">
      <h3 class="">
        {{ splitPanelHeader }}
      </h3>
      <h3 class="text-center">
        {{ splitPanelHeader2 }}
      </h3>
    </div>
    <splitpanes class="default-theme" :style="mainPanelStyle">
      <pane v-if="leftPanelVisibility" :min-size="leftPanelMinSize" :max-size="leftPanelMaxSize"
            :size="leftPanelSize">
        <slot name="left-split-panel"></slot>
      </pane>
      <pane :min-size="rightPanelMinSize" :max-size="leftPanelVisibility ? rightPanelMaxSize: 100"
            :size="rightPanelSize">
        <slot name="right-split-panel"></slot>
      </pane>
    </splitpanes>
  </div>
</template>

<script>
import {Pane, Splitpanes} from "splitpanes";

export default {
  name: "BaseBSplitPanel",
  components: {Splitpanes, Pane},
  props: {
    splitPanelHeader: {
      default: "",
      require: false,
      type: String
    },
    splitPanelHeader2: {
      default: "",
      require: false,
      type: String
    },
    rightPanelSize: {
      default: 76,
      require: false,
      type: Number
    },
    rightPanelMinSize: {
      default: 45,
      require: false,
      type: Number
    },
    rightPanelMaxSize: {
      default: 100,
      require: false,
      type: Number
    },
    leftPanelSize: {
      default: 10,
      require: false,
      type: Number
    },
    leftPanelMinSize: {
      default: 5,
      require: false,
      type: Number
    },
    leftPanelMaxSize: {
      default: 50,
      require: false,
      type: Number
    },
    mainPanelStyle: {
      default: "height: auto; padding: 10px",
      require: false,
      type: String
    },
    leftPanelVisibility: {
      default: true,
      require: false,
      type: Boolean
    },
  },
}

</script>

<style>

.splitpanes.default-theme .splitpanes__pane {
  background-color: var(--vs-search-input-bg) !important;
  border: 4px solid #f2f2f2 !important;
}

.default-theme.splitpanes--vertical > .splitpanes__splitter, .default-theme .splitpanes--vertical > .splitpanes__splitter {
  background-color: transparent !important;
  border-left: 2px solid #f2f2f2 !important;
  border-right: 2px solid #f2f2f2 !important;
  margin-left: -2px;
  margin-right: -2px;
}

</style>